<template>
    <div class="loginWrapper">
        <b-card v-if="type === 'login'" class="loginCard" title="Login" sub-title="Bitte melden Sie sich an:">
            <hr class="mt-4 mb-4">
            <b-form @submit="handleSubmit">
                <b-form-group
                    id="username-label"
                    label="Nutzername:"
                    label-for="username"
                >
                    <b-form-input
                        id="username"
                        v-model="credentials.email"
                        type="text"
                        required
                        placeholder="Nutzername eingeben"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="password-label"
                    label="Passwort:"
                    label-for="password"
                >
                    <b-form-input
                        id="password"
                        v-model="credentials.password"
                        type="password"
                        required
                        placeholder="Passwort eingeben"
                    ></b-form-input>
                </b-form-group>

                <b-button id="loginButton" type="submit" block variant="primary">Login</b-button>
            </b-form>
        </b-card>
    </div>
</template>

<script>
import store from '@/store'

export default {
    name: 'Login',
    data() {
        return {
            type: 'login',
            credentials: {
                email: '',
                password: ''
            }
        }
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()

            fetch(process.env.VUE_APP_API_URL + '/login', {
                body: JSON.stringify(this.credentials),
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
            })
                .then((response) => {
                    if (response.status !== 200) {
                        if (response.status === 401) {
                            throw new Error('' + response.status)
                        }
                        throw new Error('' + response.status + ': ' + response.statusText)
                    }

                    return response
                })
                .then(response => response.json())
                .then((response) => {
                    let token = response.data.token.plainTextToken
                    if (token !== undefined) {
                        store.commit('setAccessToken', token)
                    }
                })
                .catch(e => {
                    if (e.message === '401' || e.message === '422') {
                        this.$bvToast.toast('Nutzername oder Passwort falsch! Bitte überprüfen sie ihre Eingabe und versuchen es erneut.', {
                            title: 'Nicht autorisiert!',
                            autoHideDelay: 5000,
                            appendToast: true,
                            variant: 'danger'
                        })
                        return
                    }
                    this.$bvToast.toast('Etwas ist schief gelaufen. ' + e.message, {
                        title: 'Fehler',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'danger'
                    })
                })
        }
    }
}
</script>

<style scoped>

.loginWrapper {
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
}

.loginCard {
    max-width: 75vw;
}
</style>
